import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

/**
 * Single global self-referencing canonical for every route.
 * Mounted once at the root of the app — works automatically for every
 * existing and future page. Format: https://www.biscuitbrand.com<pathname>.
 *
 * Configurable canonical origin via REACT_APP_CANONICAL_URL.
 */
const CANONICAL_ORIGIN = (process.env.REACT_APP_CANONICAL_URL || 'https://www.biscuitbrand.com').replace(/\/+$/, '');

const buildCanonical = (pathname) => {
    let p = (pathname || '/').split('?')[0].split('#')[0];
    if (!p.startsWith('/')) p = '/' + p;
    p = p.replace(/\/{2,}/g, '/');
    if (p.length > 1 && p.endsWith('/')) p = p.slice(0, -1);
    return `${CANONICAL_ORIGIN}${p}`;
};

const Canonical = () => {
    const location = useLocation();
    const url = buildCanonical(location.pathname);
    return (
        <Helmet>
            <link rel="canonical" href={url} />
            <meta property="og:url" content={url} />
        </Helmet>
    );
};

export default Canonical;
